import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-running-jobs-widget',
  standalone: true,
  imports: [CommonModule, CardModule, SkeletonModule],
  templateUrl: './running-jobs-widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RunningJobsWidget {
  @Input() count: number = 0;
  @Input() loading: boolean = false;
}
